<template>
    <div>
        <div class="nav-tabs-container pt-1" v-if="!hideTabs">
            <div class="nav-tabs-scroll-helper">
                <ul class="nav nav-tabs">

                    <li class="nav-item">
                        <a class="nav-link" :class="{'active': mode == 'all'}" href id="tabLinkReimbursements1" role="tab" aria-controls="tabContentReimbursements1" :aria-selected="mode == 'all'" @click.prevent="mode = 'all'; $bus.$emit('resize')">
                            All Reimbursements ({{ allReimbursementsCount }})
                        </a>
                    </li>

                    <li class="nav-item">
                        <a class="nav-link" :class="{'active': mode == 'selected'}" href id="tabLinkReimbursements2" role="tab" aria-controls="tabContentReimbursements1" :aria-selected="mode == 'selected'" @click.prevent="mode = 'selected'; $bus.$emit('resize')">
                            Selected ({{ selectedReimbursementsCount }})
                        </a>
                    </li>

                </ul>
            </div>
        </div>

        <div class="flex-body flex-container tab-content reimbursement-selector">
            <div class="flex-body flex-container tab-pane" :class="{'show active': mode == 'all'}" id="tabContentReimbursements1" role="tabpanel" aria-labelledby="tabLinkReimbursements1">
                <fast-table
                    v-if="mode == 'all'"
                    :sections="reimbursementSections"
                    :headers="reimbursementHeaders"
                    :data="reimbursementTableData"
                    @click="onReimbursementClick"
                    @select="onReimbursementSelect"
                    :has-row-select="true"
                    :show-search="!hideSearch"
                    :show-filter="false"
                    :show-more-actions="false"
                />

            </div>

            <div class="flex-body flex-container tab-pane" :class="{'show active': mode == 'selected'}" id="tabContentReimbursements2" role="tabpanel" aria-labelledby="tabLinkReimbursements2">
                <fast-table
                    v-if="mode == 'selected'"
                    :sections="reimbursementSections"
                    :headers="reimbursementHeaders"
                    :data="selectedReimbursementTableData"
                    @click="onReimbursementClick"
                    @select="onReimbursementSelect"
                    :has-row-select="true"
                    :show-search="!hideSearch"
                    :show-filter="false"
                    :show-more-actions="false"
                />

            </div>
        </div>
    </div>
    </template>

    <script>
    import FastTable from '@/components/FastTable'

    export default {
        props: ['modelValue', 'selectableReimbursements', 'hideSearch', 'hideTabs'],
        emits: ['update:modelValue'],
        components: {FastTable, },
        computed: {
            reimbursementTableData() {
                const result = []

                this.reimbursements.forEach(c => {
                    result.push({
                        id: c.id,
                        isSelected: this.formData.reimbursements.includes(c.id),
                        object: c,
                        cells: [
                            c.name,
                        ],
                    })
                })

                return [result]
            },
            selectedReimbursementTableData() {
                let result = this.reimbursementTableData[0].filter(row => {
                    return this.formData.reimbursements.includes(row.object.id)
                })

                result = JSON.parse(JSON.stringify(result))
                result.forEach(row => {
                    row.isSelected = true
                })

                return [result]
            },
            allReimbursementsCount() {
                return this.reimbursementTableData[0].length
            },
            selectedReimbursementsCount() {
                return this.selectedReimbursementTableData[0].length
            },
        },
        data() {
            return {
                mode: 'all',
                reimbursements: this.selectableReimbursements || [],
                formData: {
                    reimbursements: Array.from(this.modelValue),
                },
                reimbursementSections: [
                    {title: 'All', id: 'all'},
                ],
                reimbursementHeaders: [
                        {label: 'Reimbursement', classes: 'cell-reimbursement', defaultSort: true, isFilterable: false, isSearchable: true, },
                ],
            }
        },
        mounted() {
            this.$bus.$emit('resize')
            if (!this.selectableReimbursements) {
                this.getReimbursements()
            }
        },
        methods: {
            getReimbursements() {
                this.$store.dispatch('START_LOADING')
                this.$api.get('/admin/tax-engine/reimbursement-types').then(resp => {
                    this.reimbursements = resp
                    this.$store.dispatch('STOP_LOADING')
                }).catch((errors) => {
                    this.$store.dispatch('STOP_LOADING')
                    if (errors.__status__ == 403) {
                        this.$bus.$emit('no-access')
                    }
                    else {
                        this.$bus.showError(errors.__all__)
                    }
                })
            },
            onReimbursementSelect(rows) {
                const reimbursements = new Set()
                rows.forEach(row => {
                    reimbursements.add(row.object.id)
                })

                this.formData.reimbursements = Array.from(reimbursements)

                this.$emit('update:modelValue', this.formData.reimbursements)
            },
            onReimbursementClick(reimbursement) {
                if (this.formData.reimbursements.includes(reimbursement.id)) {
                    this.formData.reimbursements = this.formData.reimbursements.filter(cId => cId != reimbursement.id)
                }
                else {
                    this.formData.reimbursements.push(reimbursement.id)
                }

                this.$emit('update:modelValue', this.formData.reimbursements)
            },
        },
    }

    </script>

    <style>
    .reimbursement-selector .table-wrapper {
        min-height: 300px;
    }
    </style>
